import React from "react";

export interface LoadingViewProps {
    message?: string;
}

export const LoadingView: React.FC<LoadingViewProps> = ({message}) => {

    return (
        <>
            <div className='circular-loading loading-body'>
                <div className="spinner">
                    <i/>
                    <i/>
                    <i/>
                    <i/>
                    <i/>
                    <i/>
                </div>
                <div className='glowing-text'>
                    <div className='d-flex flex-column justify-content-between align-items-center'>
                        <h1 className='pb-3'>
                            {message ?? ""}
                        </h1>
                        <p><span>Designed and Developed by </span>BIZKEY TECH</p>
                    </div>
                </div>
            </div>

        </>
    );
}